import { ISearchableSelectMenu } from "../../interface";
import SearchableSelectMenu from "../SearchableSelectMenu";

const NonSearchableSelectMenu: React.FC<ISearchableSelectMenu> = (props) => {
  return <SearchableSelectMenu {...props} disableSearch={true} />;
};

export default NonSearchableSelectMenu;
